import {PaginationQueryFunc} from "./pagination-query-func";
import {PaginatedResultResponse} from "./paginated-results-response";

export class PaginatedResultsLoader<T> {
    
    private _results:T[];
    private _cursor:string;
    private _hasMoreResults:boolean;
    private _clientId:string;
    private _queryFunc:PaginationQueryFunc;

    constructor(queryFunc:PaginationQueryFunc) {
        this._results = [];
        this._cursor = null;
        this._hasMoreResults = false;
        this._queryFunc = queryFunc;
    }
    
    public get cursor() : string {
        return this._cursor;
    }
    
    public set cursor(v:string) {
        this._cursor = v;
    }
    
    public hasMoreResults() {   
        return this._hasMoreResults;
    }
    
    public getResults() : Promise<T[]> {
        return this._queryFunc(this.cursor)
        .then((resultList:PaginatedResultResponse<T>) => this.handleResultsLoaded(resultList));
    }
    
    private handleResultsLoaded(resultList:PaginatedResultResponse<T>) : T[] {
        this._results = this._results.concat(resultList.results);
        this._cursor = null;
        this._hasMoreResults = false;
        
        if (typeof resultList.cursor === "string") {
            this._cursor = resultList.cursor.trim();
            this._hasMoreResults = this._cursor != "";
        }

        return this._results;
    }
    
    public loadMore() : Promise<T[]> {
        return this.getResults();
    }
    
}


// WEBPACK FOOTER //
// ./src/app/shared/models/paginated-results-loader.ts